import { useGridRootProps } from "@components/DataGrid/hooks/useGridRootProps";
import i18n from "@i18n/i18n";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Button, ButtonProps, Tooltip, TooltipProps, Typography } from "@mui/material";
import { unstable_useId as useId } from "@mui/material/utils";
import PropTypes from "prop-types";
import { forwardRef, useRef, useState } from "react";

export interface GridToolbarImportButtonProps {
  onFileImport?: (files: File[]) => Promise<void>;
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps?: { loadingButton?: Partial<ButtonProps>; tooltip?: Partial<TooltipProps> };
}

const GridToolbarImportButton = forwardRef<HTMLButtonElement, GridToolbarImportButtonProps>((props, ref) => {
  const { slotProps = {} } = props;
  const loadingButtonProps = slotProps.loadingButton || {};
  const tooltipProps = slotProps.tooltip || {};
  const importButtonId = useId();
  const inputEl = useRef<any>(null);
  const rootProps = useGridRootProps();
  const [isLoading, setIsLoading] = useState(false);

  const handleSelectFile = async (event: any) => {
    try {
      setIsLoading(true);
      await props.onFileImport?.(event.target.files);
    } finally {
      event.target.value = null;
      setIsLoading(false);
    }
  };

  //console.log("rootProps: ", rootProps);
  //console.log("slotProps: ", slotProps);

  return (
    <Tooltip title={i18n.t("grid-toolbar-import-button.title")} enterDelay={1000} {...tooltipProps} {...rootProps.slotProps?.baseTooltip}>
      <Typography component="label" htmlFor="btn-upload">
        <input hidden id="btn-upload" name="btn-upload" type="file" onChange={handleSelectFile} ref={inputEl} />
        <Button
          ref={ref}
          id={importButtonId}
          aria-label={i18n.t("grid-toolbar-import-button.title")}
          //aria-haspopup="menu"
          //aria-expanded={isOpen}
          //aria-controls={isOpen ? importPanelId : undefined}
          startIcon={<UploadFileIcon />}
          {...loadingButtonProps}
          //onClick={showImport}
          loading={isLoading}
          loadingPosition={loadingButtonProps.loadingPosition || "start"}
          component="span"
          {...rootProps.slotProps?.baseLoadingButton}
        >
          {i18n.t("grid-toolbar-import-button.title")}
        </Button>
      </Typography>
    </Tooltip>
  );

  /*
  return (
    <rootProps.slots.baseTooltip title={i18n.t("grid-toolbar-import-button.title")} enterDelay={1000} {...tooltipProps} {...rootProps.slotProps?.baseTooltip}>
        <rootProps.slots.baseLoadingButton
          ref={ref}
          id={importButtonId}
          size="small"
          aria-label={i18n.t("grid-toolbar-import-button.title")}
          aria-haspopup="menu"
          aria-expanded={isOpen}
          aria-controls={isOpen ? importPanelId : undefined}
          startIcon={<FileUploadIcon />}
          {...loadingButtonProps}
          onClick={showImport}
          loading={isLoading}
          loadingPosition={loadingButtonProps.loadingPosition || "start"}
          {...rootProps.slotProps?.baseLoadingButton}
        >
          {i18n.t("grid-toolbar-import-button.title")}
        </rootProps.slots.baseLoadingButton>
    </rootProps.slots.baseTooltip>
  );
  */
});

GridToolbarImportButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  onFileImport: PropTypes.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.object,
} as any;

export { GridToolbarImportButton };

